export default __webpack_public_path__ + "static/bg_university_kaiserslautern-ff70cbf32cc9920e10bf9966c6c47ec9.jpeg";